import { attr } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';

const Transaction = ApplicationRecord.extend({
  attrs: {
    status: attr({ type: String }),
    checkout_status: attr({ type: String }),
    checkout_response_code: attr({ type: String }),
    checkout_response_summary: attr({ type: String }),
    checkout_error_code: attr({ type: String }),
    checkout_3ds_authentication_response: attr({ type: String }),
    error_message: attr({ type: String }),
  },
  static: {
    endpoint: '/transactions',
    jsonapiType: 'external_payments-transactions',
  },
});
export default Transaction;
